import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { TextField, MenuItem, Typography, Box, Button } from '@mui/material';
import { FaArrowRight } from 'react-icons/fa';
import { useFavicon } from '../useFavicon';
import youtubeApi from '../api/youtubeApi';

const YOUTUBE_FAVICON_URL = process.env.PUBLIC_URL + "/youtube.ico"; // Add this line

const images = [
  { name: 'Tonic Center', path: '/assets/pictures/TonicCenter.jpg' },
  { name: 'Circle of Fifths', path: '/assets/pictures/CircleofFifths.jpg' }
];

function selectedImageInitialState() {
  return images[0].path;
}
function initialPosition() {
  return { left: '51%', top: '49%' };
}
var amitSelectedImage = images[0].path;
//var amitPositionType = 'tonicCenter';
var arrowRotation = 0;

const TonalityYoutubeVideoPage = () => {
  useFavicon(YOUTUBE_FAVICON_URL); // Add this line
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.info('[TonalityYoutubeVideoPage] mounted');
    return () => {
      console.info('[TonalityYoutubeVideoPage] unmounted');
    };
  }, []);

  const [selectedVideoId, setSelectedVideoId] = useState('');
  let [selectedVideo, setSelectedVideo] = useState(null);
  let [videos, setVideos] = useState([]);
  let [selectedImage, setSelectedImage] = useState(() => selectedImageInitialState());
  let [currentPosition, setCurrentPosition] = useState(initialPosition());
  let [currentText, setCurrentText] = useState('');
  let [currentTime, setCurrentTime] = useState(0);
  const playerContainerRef = useRef(null);
  const playerRef = useRef(null);
  const playerReadyRef = useRef(false);
  let [selectedInterval, setCurrentInterval] = useState(null);
  const [circleRadius, setCircleRadius] = useState(20); // Initial radius
  const circleRadiusRef = useRef(circleRadius); // Ref for the circleRadius
  let imageRef = useRef(null); // Ref for the image
  let [imageHeight, setImageHeight] = useState('100%');
  const [topCenter, setTopCenter] = useState(50); // Initial topCenter
  const [baseLeft, setBaseLeft] = useState(50); // Initial baseLeft
  const topCenterRef = useRef(topCenter);
  const baseLeftRef = useRef(baseLeft);
  const [positionType, setPosiotionType] = useState('tonicCenter'); // Initial positionType
  const positionTypeRef = useRef(positionType); // Ref for the positionType
  const needsUnmuteRef = useRef(false);
  const [topBarHeight, setTopBarHeight] = useState(0);
  const imageContainerRef = useRef(null);
  const [imageMetrics, setImageMetrics] = useState({
    offsetX: 0,
    offsetY: 0,
    width: 0,
    height: 0
  });
  const [chordPulseKey, setChordPulseKey] = useState(0);
  const lastIntervalIndexRef = useRef(null);

  var horizontalAdjustment = 2.3; // Adjustment value
  const circleOfFifthsHorizontalAdjustment = 6;
  const circleOfFifthsVerticalAdjustment = 6;

  const calculateAdjustment = () => {
    
    horizontalAdjustment = 2.75 ;// Adjust the factor as needed
    circleRadiusRef.current = imageRef.current.offsetWidth * 0.02; // Adjust the factor as needed
    
    var radiusPercentageHorizontal = circleRadiusRef.current / imageRef.current.offsetWidth *100;
    var radiusPercentageVertical = circleRadiusRef.current / imageRef.current.offsetHeight *100;
    setTopCenter(50-(radiusPercentageVertical/2));
    topCenterRef.current = 50-(radiusPercentageVertical/2);
    
    //setBaseLeft(50-(radiusPercentageHorizontal/2));
    //baseLeftRef.current = 50-(radiusPercentageHorizontal/2);

  }
  const getPositions = () => {
    var radiusPercentageHorizontal = circleRadiusRef.current / imageRef.current.offsetWidth *100;
    return {
      "tonicCenter": {
        "I": { text: " I ", left: `${baseLeftRef.current}%`, top: `${topCenterRef.current}%` },
        "II": { text: " II ", left: `54.1%`, top: `${topCenterRef.current}%` },
        "III": { text: " III ", left: `58.3%`, top: `${topCenterRef.current}%` },
        "IV": { text: " IV ", left: `33.33%`, top: `${topCenterRef.current}%` },
        "V": { text: " V ", left: `66.66%`, top: `${topCenterRef.current}%` },
        "VI": { text: " VI ", left: `41.6%`, top: `${topCenterRef.current}%` },
        "VII": { text: " VII ", left: `45.8%`, top: `${topCenterRef.current}%` },
        "-": { text: " -?- ", left: `${baseLeftRef.current}%`, top: `${topCenterRef.current}%` }
      },
      "circleOfFifths": {
        "I": { text: " I ", left: `${baseLeft + 2 * circleOfFifthsHorizontalAdjustment}%`, top: `${topCenter - 3 * circleOfFifthsVerticalAdjustment}%` },
        "II": { text: " II ", left: `${baseLeft - 3 * circleOfFifthsHorizontalAdjustment}%`, top: `${topCenter - 1 * circleOfFifthsVerticalAdjustment}%` },
        "III": { text: " III ", left: `${baseLeft - 0.2 * circleOfFifthsHorizontalAdjustment}%`, top: `${topCenter + 5.5 * circleOfFifthsVerticalAdjustment}%` },
        "IV": { text: " IV ", left: `${baseLeft + 3 * circleOfFifthsHorizontalAdjustment}%`, top: `${topCenter + 2 * circleOfFifthsVerticalAdjustment}%` },
        "V": { text: " V ", left: `${baseLeft - 1 * circleOfFifthsHorizontalAdjustment}%`, top: `${topCenter - 4 * circleOfFifthsVerticalAdjustment}%` },
        "VI": { text: " VI ", left: `${baseLeft - 2.5 * circleOfFifthsHorizontalAdjustment}%`, top: `${topCenter + 2.5 * circleOfFifthsVerticalAdjustment}%` },
        "VII": { text: " VII ", left: `${baseLeft + 2 * circleOfFifthsHorizontalAdjustment}%`, top: `${topCenter + 5 * circleOfFifthsVerticalAdjustment}%` }
      }
    };
  };

  const getArrowRotation = (position) => {
    const rotations = {
      "I": 315,
      "II": 190,
      "III": 100,
      "IV": 0,
      "V": 250,
      "VI": 150,
      "VII": 45,
      "-": 0
    };
    return rotations[position] || 0;
  };

  const calculateShortestRotation = (currentRotation, targetRotation) => {
    const difference = targetRotation - currentRotation;
    if (difference > 180) {
      return currentRotation + (difference - 360);
    } else if (difference < -180) {
      return currentRotation + (difference + 360);
    } else {
      return currentRotation + difference;
    }
  };

  const updatePosition = useCallback((currentTime) => {
    if (imageRef.current) {
      calculateAdjustment();
    }
    if (!selectedVideo || !selectedVideo.intervals) return;

    const baseStartTime = Number(selectedVideo.baseStartTime) || 0;
    const durationFactor = Number(selectedVideo.durationFactor) || 1;

    let elapsedTime = baseStartTime; // the time the chords are starting
    for (let intervalIndex = 0; intervalIndex < selectedVideo.intervals.length; intervalIndex += 1) {
      const interval = selectedVideo.intervals[intervalIndex];
      const intervalDuration = Number(interval.duration) || 0;
      elapsedTime += intervalDuration * durationFactor;
      if (currentTime <= elapsedTime) {
        
        const positions = getPositions()[positionTypeRef.current];
        if (!positions) {
          console.error(`Invalid positionType: ${positionTypeRef.current}`);
          return;
        }
        const newPosition = positions[interval.position] || positions["-"];
        if (!newPosition) {
          console.error(`Invalid interval position: ${interval.position}`);
          return;
        }

        const leftPercent = parseFloat(newPosition.left);
        const topPercent = parseFloat(newPosition.top);

        if (!Number.isNaN(leftPercent) && !Number.isNaN(topPercent) && imageMetrics.width > 0 && imageMetrics.height > 0) {
          const contentWidthFactor = 1.09;
          const contentWidth = imageMetrics.width * contentWidthFactor;
          const contentOffsetX = imageMetrics.offsetX - (contentWidth - imageMetrics.width) / 2;
          const leftPx = contentOffsetX + (leftPercent / 100) * contentWidth;
          const topPx = imageMetrics.offsetY + (topPercent / 100) * imageMetrics.height;
          setCurrentPosition({ left: `${leftPx}px`, top: `${topPx}px` });
        } else {
          setCurrentPosition({ left: newPosition.left, top: newPosition.top });
        }
        setCurrentText(newPosition.text);
        setCurrentTime(currentTime);
        setCurrentInterval(interval);

          if (lastIntervalIndexRef.current !== intervalIndex) {
            lastIntervalIndexRef.current = intervalIndex;
            setChordPulseKey((prev) => prev + 1);
          }

        if (positionTypeRef.current === 'circleOfFifths') {
          const newRotation = getArrowRotation(interval.position);
          const shortestRotation = calculateShortestRotation(arrowRotation, newRotation);
          arrowRotation = shortestRotation;
        }

        break;
      }
    }
  }, [selectedVideo, selectedInterval, calculateAdjustment, getPositions, getArrowRotation, calculateShortestRotation, imageMetrics]);

  useEffect(() => {
    fetchVideos();
  }, [location.search]);

  useEffect(() => {
    const updateTopBarHeight = () => {
      const header = document.querySelector('header');
      const height = header ? header.getBoundingClientRect().height : 0;
      setTopBarHeight(height);
    };

    updateTopBarHeight();
    window.addEventListener('resize', updateTopBarHeight);

    return () => {
      window.removeEventListener('resize', updateTopBarHeight);
    };
  }, []);

  const updateImageMetrics = useCallback(() => {
    if (!imageRef.current || !imageContainerRef.current) {
      return;
    }

    const imageRect = imageRef.current.getBoundingClientRect();
    const containerRect = imageContainerRef.current.getBoundingClientRect();

    const offsetX = imageRect.left - containerRect.left;
    const offsetY = imageRect.top - containerRect.top;

    setImageMetrics({
      offsetX,
      offsetY,
      width: imageRect.width,
      height: imageRect.height
    });
  }, []);

  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      updateImageMetrics();
    });
    window.addEventListener('resize', updateImageMetrics);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', updateImageMetrics);
    };
  }, [updateImageMetrics, selectedImage, topBarHeight, selectedVideoId]);

  const initializePlayer = useCallback(() => {
    if (!selectedVideo?.videoId || playerRef.current || !playerContainerRef.current) {
      return;
    }

    const createPlayer = () => {
      try {
        playerRef.current = new window.YT.Player(playerContainerRef.current, {
          height: '315',
          width: '560',
          videoId: selectedVideo.videoId,
          playerVars: {
            autoplay: 1,
            controls: 1,
            modestbranding: 1,
            rel: 0,
            start: selectedVideo.customStartTime || 0,
            enablejsapi: 1,
            origin: window.location.origin
          },
          events: {
            onReady: (event) => {
              playerReadyRef.current = true;
              try {
                event.target.mute();
                if (selectedVideo.customStartTime) {
                  event.target.seekTo(selectedVideo.customStartTime, true);
                }
                event.target.playVideo();
                needsUnmuteRef.current = true;
              } catch (error) {
                console.error('Error during player onReady:', error);
              }
            },
            onError: (event) => {
              console.error('YouTube Player Error:', event.data);
            }
          }
        });
      } catch (error) {
        console.error('Error initializing YouTube player:', error);
      }
    };

    if (window.YT && window.YT.Player) {
      createPlayer();
      return;
    }

    if (!document.getElementById('youtube-iframe-api')) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      tag.id = 'youtube-iframe-api';
      document.body.appendChild(tag);
    }

    window.onYouTubeIframeAPIReady = () => {
      createPlayer();
    };
  }, [selectedVideo]);

  useEffect(() => {
    initializePlayer();
  }, [initializePlayer]);

  useEffect(() => {
    if (!playerRef.current || !playerReadyRef.current || !selectedVideo?.videoId) {
      return;
    }

    try {
      playerRef.current.loadVideoById({
        videoId: selectedVideo.videoId,
        startSeconds: selectedVideo.customStartTime || 0
      });
      try {
        playerRef.current.mute();
        needsUnmuteRef.current = true;
      } catch (error) {
        console.error('Error muting player:', error);
      }
    } catch (error) {
      console.error('Error loading video:', error);
    }
  }, [selectedVideo]);

  useEffect(() => {
    const unmuteHandler = () => {
      if (!playerRef.current || !needsUnmuteRef.current) {
        return;
      }

      try {
        playerRef.current.unMute();
        needsUnmuteRef.current = false;
      } catch (error) {
        console.error('Error unmuting player:', error);
      }
    };

    document.addEventListener('click', unmuteHandler, true);
    document.addEventListener('keydown', unmuteHandler, true);
    document.addEventListener('touchstart', unmuteHandler, true);

    return () => {
      document.removeEventListener('click', unmuteHandler, true);
      document.removeEventListener('keydown', unmuteHandler, true);
      document.removeEventListener('touchstart', unmuteHandler, true);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!playerRef.current || !playerReadyRef.current) {
        return;
      }

      try {
        const currentTime = playerRef.current.getCurrentTime();
        updatePosition(currentTime);

        if (selectedVideo?.customEndTime && currentTime >= selectedVideo.customEndTime) {
          playerRef.current.pauseVideo();
        }
      } catch (error) {
        console.error('Error reading player time:', error);
      }
    }, 250);

    return () => clearInterval(interval);
  }, [selectedVideo, updatePosition]);
  useEffect(() => {
    const handleResize = () => {
      if (imageRef.current) {
        const newRadius = imageRef.current.offsetWidth * 0.02; // Adjust the factor as needed
        setCircleRadius(newRadius);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Set initial radius

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setImageHeight('100%');
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const newPositionType = selectedImage.includes('CircleofFifths') ? 'circleOfFifths' : 'tonicCenter';
    setPosiotionType(newPositionType);
    positionTypeRef.current = newPositionType;
    //amitPositionType = newPositionType;
    
  }, [selectedImage]);

  useEffect(() => {
    
  }, [selectedImage]);

  const fetchVideos = async () => {
    try {
      console.info('[TonalityYoutubeVideoPage] fetching videos');
      const response = await youtubeApi.getAll();
      setVideos(response.data);
      if (response.data.length > 0) {
        const params = new URLSearchParams(location.search);
        const requestedCustomVideoId = params.get('customVideoId');
        const requestedVideoId = params.get('videoId');
        const requestedId = params.get('id');

        let defaultVideo = null;

        if (requestedCustomVideoId) {
          defaultVideo = response.data.find(
            (video) => video.customVideoId === requestedCustomVideoId || video._id === requestedCustomVideoId
          );
        }

        if (!defaultVideo && requestedId) {
          defaultVideo = response.data.find((video) => video._id === requestedId);
        }

        if (!defaultVideo && requestedVideoId) {
          defaultVideo = response.data.find((video) => video.videoId === requestedVideoId);
        }

        if (!defaultVideo) {
          const defaultVideoIndex = 0;
          defaultVideo = response.data[defaultVideoIndex] || response.data[0];
        }

        if (defaultVideo) {
          console.info('[TonalityYoutubeVideoPage] selected video', {
            name: defaultVideo.name,
            videoId: defaultVideo.videoId,
            customVideoId: defaultVideo.customVideoId
          });
          setSelectedVideoId(defaultVideo.videoId);
          setSelectedVideo(defaultVideo);
        }
      }
      if (!selectedImage) {
        setSelectedImage(images[0].path); // Select the first image by default only if not already set
      }
    } catch (error) {
      console.error('Error fetching videos:', error);
    }
  };

  const handleVideoChange = (event) => {
    const videoId = event.target.value;
    setSelectedVideoId(videoId);
    const video = videos.find(v => v.videoId === videoId);
    if (video) {
      console.info('[TonalityYoutubeVideoPage] user selected video', {
        name: video.name,
        videoId: video.videoId,
        customVideoId: video.customVideoId
      });
    }
    setSelectedVideo(video);
    calculateAdjustment();
  };

  const handleImageChange = (event) => {
    const selectedImagePath = event.target.value;
    setSelectedImage(selectedImagePath);
    amitSelectedImage = selectedImagePath;
    setImageHeight('100%');
    updatePosition(currentTime); // Update position immediately after changing the image
  };


  const handleReload = () => {
    fetchVideos();
  };

  // Update arrow rotation
  function updateArrowRotation(interval) {
    if (!interval) {
      return;
    }
    const semitones = interval.semitones || 0;
    arrowRotation = semitones * 30;
  }

  // Navigation handler
  const handleBackToMain = () => {
    navigate('/'); // Navigate to the main page
  };

  const visibleCircleRadius = Math.max(circleRadius || 0, 19);
  const contentWidthFactor = 1.09; // Slightly expand to align with tick marks
  const contentWidth = imageMetrics.width * contentWidthFactor;
  const contentOffsetX = imageMetrics.offsetX - (contentWidth - imageMetrics.width) / 2;
  const contentCenterY = imageMetrics.offsetY + imageMetrics.height * 0.5;

  

  return (
    <Box
      sx={{
        p: 2,
        height: topBarHeight ? `calc(100vh - ${topBarHeight}px)` : '100vh',
        boxSizing: 'border-box',
        overflow: 'hidden'
      }}
    >
      <style>
        {`@keyframes chordPulse {0% { box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.6); } 70% { box-shadow: 0 0 16px 10px rgba(255, 0, 0, 0.35); } 100% { box-shadow: 0 0 0 0 rgba(255, 0, 0, 0); } }`}
      </style>
      <Box sx={{ display: 'flex', gap: 2, height: '100%', overflow: 'hidden' }}>
        <Box
          sx={{
            flex: '0 0 15%',
            maxWidth: '15%',
            minWidth: 220,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            overflow: 'hidden'
          }}
        >
          {selectedVideoId && (
            <>
              <TextField
                select
                label="Select Video"
                value={selectedVideoId}
                onChange={handleVideoChange}
                variant="outlined"
                fullWidth
                sx={{ mt: 1 }}
              >
                {videos.map((video) => (
                  <MenuItem key={video._id} value={video.videoId}>
                    {video.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                label="Current Position"
                value={`${currentText} at ${currentTime.toFixed(2)}s`}
                variant="outlined"
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
              <Button variant="contained" color="primary" onClick={handleReload}>
                Reload Data
              </Button>
              <TextField
                select
                label="Select Image"
                value={selectedImage}
                onChange={handleImageChange}
                variant="outlined"
                fullWidth
              >
                {images.map((image) => (
                  <MenuItem key={image.path} value={image.path}>
                    {image.name}
                  </MenuItem>
                ))}
              </TextField>
            </>
          )}
          <Box sx={{ mt: 'auto' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleBackToMain}
              fullWidth
            >
              Back to Main Page
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            flex: '1 1 85%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            height: '100%',
            minHeight: 0,
            overflow: 'hidden'
          }}
        >
          {selectedVideoId && (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  maxWidth: 960,
                  height: '35vh',
                  minHeight: 200,
                  maxHeight: 360
                }}
              >
                <div
                  ref={playerContainerRef}
                  id="youtube-player"
                  style={{ width: '100%', height: '100%' }}
                />
              </Box>
            </Box>
          )}

          {selectedImage && (
            <Box
              ref={imageContainerRef}
              sx={{
                flex: '1 1 auto',
                minHeight: 0,
                width: '100%',
                maxHeight: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                p: 1
              }}
            >
              <img
                ref={imageRef}
                src={selectedImage}
                alt="Selected"
                style={{ maxWidth: '100%', maxHeight: '100%', height: '100%', objectFit: 'contain' }}
                onLoad={updateImageMetrics}
              />
              {positionType !== 'circleOfFifths' && (
                <div
                  key={`chord-${chordPulseKey}`}
                  style={{
                    position: 'absolute',
                    left: currentPosition.left,
                    top: currentPosition.top,
                    width: `${visibleCircleRadius}px`,
                    height: `${visibleCircleRadius}px`,
                    backgroundColor: selectedInterval?.Modulation === true ? 'yellow' : 'red',
                    borderRadius: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 2,
                    boxShadow: '0 0 6px rgba(0, 0, 0, 0.3)',
                    transition: 'left 0.2s ease-in-out, top 0.5s ease-in-out',
                    animation: 'chordPulse 0.6s ease-out'
                  }}
                ></div>
              )}
              {positionType === 'circleOfFifths' && (
                <FaArrowRight
                  key={`chord-arrow-${chordPulseKey}`}
                  style={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    fontSize: '200px',
                    color: 'red',
                    transform: `translate(-50%, -50%) rotate(${arrowRotation}deg)`,
                    transformOrigin: 'center center',
                    transition: 'transform 0.2s ease-in-out',
                    animation: 'chordPulse 0.6s ease-out'
                  }}
                />
              )}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default TonalityYoutubeVideoPage;
